import { Box } from '@mui/material';
import { useStyles } from './styles';

// Vite's import.meta.glob replaces webpack's require.context
const svgModules = import.meta.glob('../../assets/svg/feedback-icon/*.svg', { eager: true });

function RadioImage({ title, inputID, inputName, value, imgUrl, imgAlt, styles: propStyles, handleChange, selectedValue, positionLabel, textStyle }) {
  const classes = useStyles();

  const getPositionStyles = (position) => {
    switch (position) {
      case 'top':
        return {
          display: 'flex',
          flexDirection: 'column-reverse',
          alignItems: 'center',
        };
      case 'left':
        return {
          display: 'flex',
          flexDirection: 'row-reverse',
          alignItems: 'center',
        };
      case 'right':
        return {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        };
      default:
        return {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        };
    }
  };

  // Helper to get SVG from the glob result
  const getSvg = (name) => {
    const key = `../../assets/svg/feedback-icon/${name}.svg`;
    return svgModules[key]?.default || svgModules[`../../assets/svg/feedback-icon/thumb-default.svg`]?.default;
  };

  const svgIcon = getSvg(imgUrl) || getSvg('thumb-default');

  return (
    <Box sx={{ ...classes.crSelector, ...getPositionStyles(positionLabel) }}>
      <input id={inputID} type="radio" name={inputName} value={value} onChange={handleChange} checked={selectedValue === value} />
      <Box component="label" sx={selectedValue ? classes.crLabelImg : undefined} htmlFor={inputID}>
        <img alt={imgAlt} width={propStyles?.imgWidth || '70'} height={propStyles?.imgHeight || '70'} src={svgIcon} />
      </Box>
      <Box component="label" sx={classes.crTitle} style={textStyle} htmlFor={inputID}>
        {title}
      </Box>
    </Box>
  );
}

export default RadioImage;
